import { TELENOR_API_URL, TELENOR_API_URL_PROD } from "../../env";
import { ApiName } from "./ApiName";

export function getApiUrl(name?: ApiName) {
  switch (name) {
    case "Autolog":
      return TELENOR_API_URL;
    case "AutologProd":
      return TELENOR_API_URL_PROD;
    case "flows":
      return `${TELENOR_API_URL}/flows`;
    default:
      return TELENOR_API_URL;
  }
}
